import React, { useState, useEffect } from "react";
import renderScatterplot from "./chart";
import styles from "./Scatterplot.module.css";
import FreeSolo from "./Search";
import "./Scatterplot.css";

const Scatterplot = ({ data }) => {
  const [mode, setMode] = useState("income");
  const [selectedNeighborhood, setSelectedNeighborhood] = useState("");
  const [mobile, setMobile] = useState(window.innerWidth < 500);

  useEffect(
    () => renderScatterplot(data, mode, selectedNeighborhood, mobile),
    [mode, selectedNeighborhood, mobile]
  );

  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth < 500 && !mobile) {
        return setMobile(true);
      }
      if (window.innerWidth >= 500 && mobile) {
        return setMobile(false);
      }
    });
  });

  return (
    <div className={styles.Scatter}>
      <div className={styles.Desc}>
        <h3>Socio-Economic Trends of Homicides</h3>
        <p>
          Many factors play into communities that are affected by high homicide
          rates throughout Chicago. See how strong or weak different
          socio-economic factors trend with homicides throughout the city
        </p>
        <div className={styles.ButtonContainer}>
          <button
            className={mode === "income" ? styles.Active : null}
            onClick={() => setMode("income")}
          >
            Income
          </button>
          <button
            className={mode === "graduation" ? styles.Active : null}
            onClick={() => setMode("graduation")}
          >
            % with a High School Diploma or higher
          </button>
          <button
            className={mode === "unemployment" ? styles.Active : null}
            onClick={() => setMode("unemployment")}
          >
            Unemployment Rate
          </button>
        </div>
        <FreeSolo
          data={data.sort((a, b) =>
            a.communityarea > b.communityarea ? 1 : -1
          )}
          selectNeighborhood={(sel) => setSelectedNeighborhood(sel)}
        />
      </div>
      <div id="scatterplot_container">
        <div id="scatterplot_inner_container">
          <div id="scatterplot_labels">
            <div id="scatterplot_median_label" />
            <div id="scatterplot_y_labels" />
            <div id="scatterplot_x_labels" />
            <div id="scatterplot_neighborhood_label" />
          </div>
          <div id="scatterplot">
            <svg
              viewBox={`0 0 500 ${mobile ? 500 : 300}`}
              preserveAspectRatio="xMinYMin slice"
              width="100%"
              height="100%"
            ></svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Scatterplot;
